var map = {
	"./item1.jpg": 6356,
	"./item2.jpg": 2419,
	"./item3.jpg": 2310,
	"./item4.jpg": 2157,
	"./item5.jpg": 7264,
	"./item6.jpg": 4639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7824;